/**
 * 渠道包列表页面
 */
import React from 'react'
import PureList from 'pureComponents/PureList'
import { CHANNEL_PKG_LIST, CHANNEL_PKG_STATUS_LIST } from './constants'
import useChannelPkgList from './hooks/useChannelPkgList'

const ChannelPkgList = (props = {}) => {
    const appInfo = props
    const { name, versionName, versionCode, openAppId } = appInfo
    const { state, setState, colRender, HeaderRightAddOn, bodyHeight } = useChannelPkgList(appInfo)
    const setCellStyle = (type, dataName, value, rowIndex, colIndex, data) => {
        if (type !== 'data') return

        if (data.borderBottomNone) {
            return {
                borderBottom: 'none',
                paddingBottom: 0,
            }
        }
    }
    return (
        <div className="splitview-secs main main-full">
            <div className="titlebar splitview-titlebar channel-package-titlebar">
                <h2 className="title">{name}</h2>
                <div className="desc">
                    <div className="desc-item">应用 ID：{openAppId}</div>
                    <div className="desc-item">版本：{versionName}</div>
                    <div className="desc-item">Version Code：{versionCode}</div>
                </div>
            </div>
            <div className="card card-full">
                <PureList
                    {...state}
                    {...setState}
                    setState={setState}
                    columnsConfig={CHANNEL_PKG_LIST}
                    colRender={colRender}
                    filterSelectData={CHANNEL_PKG_STATUS_LIST}
                    HeaderRightAddOn={HeaderRightAddOn}
                    title={'渠道包列表'}
                    searchPlaceholder="渠道包名称"
                    showFilter={false}
                    fixedHeight={bodyHeight}
                    setCellStyle={setCellStyle}
                />
            </div>
        </div>
    )
}

export default ChannelPkgList
